import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { appName } from "../../../app.json";
import ActivePage from "../../../partials/active-page";
import NewDepartmentForm from "./NewDepartment.jsx";
import {
	GET_DEPARTMENT,
	NEW_DEPARTMENT,
	UPDATE_DEPARTMENT
} from "../../../queries/department.query";
import { useQuery, useMutation } from "@apollo/react-hooks";
import AlertMessage from "../../../partials/alertMessage";
import LoadingSpinner from "../../../partials/loading";
import DepartmentList from "./DepartmentList";
import auth from "../../../providers/Auth.Provider";
import UpdateDepartment from "./UpdateDepartment.jsx";

const Department = ({ match }) => {
	// local state
	const [newDepartment, setNewDepartment] = useState(false);
	const [department, setDepartment] = useState(null);
	// site
	const { GetToken, GetAuthenticatedStaff } = auth.authProvider;
	const { site } = GetToken() && GetAuthenticatedStaff();

	// prepare query
	const { loading: gLoading, data: gData, error: gError } = useQuery(
		GET_DEPARTMENT,
		{ variables: { site: site && site.id } }
	);

	// prepare mutation
	const [
		CreateDepartment,
		{ loading: nLoading, data: nData, error: nError }
	] = useMutation(NEW_DEPARTMENT, {
		update(
			caches,
			{
				data: { CreateDepartment }
			}
		) {
			const { GetDepartments } = caches.readQuery({
				query: GET_DEPARTMENT,
				variables: { site: site && site.id }
			});
			// update
			GetDepartments.docs.unshift(CreateDepartment.doc);
			// write back
			caches.writeQuery({
				data: { GetDepartments },
				variables: { site: site && site.id },
				query: GET_DEPARTMENT
			});
		}
	});

	// prepare Update mutation
	const [
		UpdateDepartmentFunc,
		{ loading: uLoading, data: uData, error: uError }
	] = useMutation(UPDATE_DEPARTMENT);
	// props
	const title = "Staff Department";
	const pages = [
		{
			title: "Application Management",
			path: "/home/app-management"
		},
		{ title, path: match.path }
	];

	return (
		<>
			<Helmet>
				<title>
					{title} | {appName}
				</title>
			</Helmet>
			<ActivePage pages={pages} title={title} />

			<div className="row justify-content-center">
				{newDepartment && (
					<div className="col-md-8 col-sm-12 fade-in">
						<div className="card">
							<div className="card-head">
								<header>New Department</header>
							</div>
							<div className="card-body m-b-20">
								<LoadingSpinner loading={nLoading} />
								<AlertMessage
									message={nError && nError.message}
									failed={true}
								/>
								<AlertMessage
									message={nData && nData.CreateDepartment.message}
									failed={false}
								/>
								<NewDepartmentForm
									onCancel={() => setNewDepartment(false)}
									onSubmit={async name => {
										await CreateDepartment({
											variables: { site: site && site.id, name }
										});
									}}
								/>
							</div>
						</div>
					</div>
				)}
				{department && (
					<div className="col-md-8 col-sm-12 fade-in">
						<div className="card">
							<div className="card-head">
								<header>Update Department</header>
							</div>
							<div className="card-body m-b-20">
								<LoadingSpinner loading={uLoading} />
								<AlertMessage
									message={uError && uError.message}
									failed={true}
								/>
								<AlertMessage
									message={uData && uData.UpdateDepartment.message}
									failed={false}
								/>
								<h5>{department.name}: </h5>
								<UpdateDepartment
									onCancel={() => {
										setDepartment(null);
										setNewDepartment(false);
									}}
									onSubmit={async name => {
										await UpdateDepartmentFunc({
											variables: { id: department.id, name }
										});
										setDepartment(null);
									}}
									currentValue={department.name}
								/>
							</div>
						</div>
					</div>
				)}
				<div className="col-md-8 col-sm-12">
					<div className="card">
						<div className="card-head">
							<header>Department List</header>
							<div className="tools">
								<button
									title="Add Department"
									onClick={() => {
										setNewDepartment(true);
										setDepartment(null);
									}}
									className="mdl-button mdl-button--icon margin-right-10 btn-success"
								>
									<i className="material-icons">add</i>
								</button>
							</div>
						</div>
						<div className="card-body">
							<LoadingSpinner loading={gLoading} />
							<AlertMessage message={gError && gError.message} failed={true} />
							{!gLoading && (
								<DepartmentList
									items={gData && gData.GetDepartments.docs}
									onEdit={item => {
										setDepartment(item);
										setNewDepartment(false);
										document.body.scrollTop = 0;
										document.documentElement.scrollTop = 0;
									}}
								/>
							)}
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default Department;
